export const TestIds = {
  container: 'chat-welcome-message',
};
